module.exports = __webpack_public_path__ + "img/jd_qd@2x.8f8ed85b.png";